import { render, staticRenderFns } from "./dongxing.vue?vue&type=template&id=fc680bbc&scoped=true"
import script from "./dongxing.vue?vue&type=script&lang=js"
export * from "./dongxing.vue?vue&type=script&lang=js"
import style0 from "./dongxing.vue?vue&type=style&index=0&id=fc680bbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc680bbc",
  null
  
)

export default component.exports